import { lazy } from 'react';

export const UpsertSubscriptionPlanAsync = lazy(
 () => import('./UpsertSubscriptionPlan')
);
